import { isNull, isUndefined } from 'lodash';
import dayjs from 'dayjs';
import moment from 'moment';

export const maskPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return '(***) ***-****';

  return `(***) ***-${phoneNumber.substr(-4, 4)}`;
};

export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return '';

  const match = phoneNumber.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return phoneNumber;
};

export const formatDateOfBirth = (date) => {
  let temp = date;
  if (temp) {
    if (temp.indexOf('/') !== -1) {
      temp = temp.split(' / ').join('');
    } else {
      temp = temp.slice(4, 6) + temp.slice(6, 8) + temp.slice(0, 4);
    }
  }
  return temp;
};

export const serializeDateOfBirth = (date) => {
  if (date) {
    return `${date.slice(0, 2)}/${date.slice(2, 4)}/${date.slice(4, 8)}`;
  }
  return date;
};

export const formatDatePicker = (date) => {
  // eslint-disable-next-line no-restricted-globals
  if (date instanceof Date && !isNaN(date)) {
    return moment(date).format('MM/DD/YYYY');
  }
  return date;
};

export const formatLoanPurpose = (loanPurpose) => {
  let response;
  if (loanPurpose === '') {
    response = 'Skipped';
  } else {
    response = loanPurpose;
  }

  return response;
};

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});

export const formatCurrency = (amount) => {
  if (isNull(amount) || isUndefined(amount)) return amount;
  return formatter.format(amount);
};

export const formatDate = (date) => {
  if (date) {
    return moment(date).format('MM/DD/YYYY');
  }
  return date;
};

export const formatDayjsDate = (date) => {
  if (date) {
    return dayjs(date).format('MM/DD/YYYY');
  }
  return date;
};

export const formatPaymentDate = (date) => {
  if (date) {
    return moment(date).format('MMMM Do, YYYY');
  }
  return date;
};

export const formatOneTimePaymentDate = (date) => {
  if (date) {
    return moment(date).format('MMMM Do');
  }
  return date;
};
